import styled from 'styled-components';
import IconArrowOrange from '../../assets/images/icon-arrow.svg';
import IconArrowBlue from '../../assets/images/icon-arrow-blue.svg';
import {useTranslation} from 'react-i18next';
import {SectionContainer, SectionTitle} from './Layout';

type Props = {
  onLinkClick: () => void;
  onEmailClick: () => void;
  onLogsClick: () => void;
};

const SectionInvitation = ({onLinkClick, onEmailClick, onLogsClick}: Props) => {
  const {t} = useTranslation();

  return (
    <SectionContainer>
      <SectionTitle>{t('dashboard.invite-users-section-title')}</SectionTitle>
      <Row>
        <Box
          title={t('dashboard.copy-link')}
          description={t('dashboard.copy-link-description')}
          onClick={onLinkClick}
        />
        <Box
          title={t('dashboard.invite-by-email')}
          description={t('dashboard.invite-by-email-description')}
          onClick={onEmailClick}
        />
        <Box
          title={t('dashboard.logs-title')}
          description={t('dashboard.logs-description')}
          onClick={onLogsClick}
        />
      </Row>
    </SectionContainer>
  );
};

type BoxProps = {
  title: string;
  description: string;
  onClick: () => void;
};

const Box = ({title, description, onClick}: BoxProps) => {
  return (
    <BoxContainer onClick={onClick}>
      <BoxTitle>{title}</BoxTitle>
      <BoxDescription>{description}</BoxDescription>
    </BoxContainer>
  );
};

export default SectionInvitation;

const BoxContainer = styled.div`
  position: relative;
  flex: 1;
  border: solid 1px transparent;
  border-radius: 0.25rem;
  background-color: #f8f7fd;
  padding: 1.5rem;
  padding-right: 4.5rem;

  @media ${(props) => props.theme.breakpoints.landscape} {
    flex-basis: 100%;
  }

  &::after {
    content: '';
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    position: absolute;
    top: 50%;
    right: 1.5rem;
    border-radius: 100%;
    transform: translateY(-50%);
    border: solid 0.125rem ${(p) => p.theme.colors.violet500};
    background-image: url(${IconArrowBlue});
    background-position: center;
    background-size: 120%;
    background-repeat: no-repeat;
  }

  &:hover {
    cursor: pointer;
    background-color: #fef7f1;
    border-color: ${(p) => p.theme.colors.orange500};

    span {
      color: ${(p) => p.theme.colors.orange500};
    }

    &::after {
      border-color: ${(p) => p.theme.colors.orange500};
      background-image: url(${IconArrowOrange});
    }
  }
`;
const BoxTitle = styled.span`
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 800;
  color: ${(p) => p.theme.colors.violet500};
`;
const BoxDescription = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  grid-gap: 2rem;
  row-gap: 1rem;
  flex-wrap: wrap;
`;
